import { DataMapperMappingTypes } from './enums/data-mapper-mapping-types';
import { TransformFunctionType } from './enums/transform-function-types.enum';

interface FunctionType {
	id: number;
	type: TransformFunctionType;
	dataType: 'string' | 'number' | 'date' | 'object' | 'arrayObject'; //The input data type
	inputTypes?: string[][];
}

// Also add to transform-function-types.enum.ts
export const DataMapperTransformFunctions: FunctionType[] = [
	{
		id: 0,
		type: TransformFunctionType.Trim,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string]],
	},
	{
		id: 1,
		type: TransformFunctionType.TrimStart,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string]],
	},
	{
		id: 2,
		type: TransformFunctionType.TrimEnd,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string]],
	},
	{
		id: 3,
		type: TransformFunctionType.Replace,
		dataType: 'string',
		inputTypes: [
			[DataMapperMappingTypes.string],
			[DataMapperMappingTypes.string],
			[DataMapperMappingTypes.string],
		],
	},
	{
		id: 4,
		type: TransformFunctionType.ToUpperCase,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string]],
	},
	{
		id: 5,
		type: TransformFunctionType.ToLowerCase,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string]],
	},
	{
		id: 6,
		type: TransformFunctionType.AddPrefix,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string], [DataMapperMappingTypes.string]],
	},
	{
		id: 7,
		type: TransformFunctionType.AddSuffix,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string], [DataMapperMappingTypes.string]],
	},
	{
		id: 18,
		type: TransformFunctionType.Combine,
		dataType: 'string',
		inputTypes: [[DataMapperMappingTypes.string], [DataMapperMappingTypes.string]],
	},
	{
		id: 30,
		type: TransformFunctionType.Substring,
		dataType: 'string',
		inputTypes: [
			[DataMapperMappingTypes.string],
			[DataMapperMappingTypes.string],
			[DataMapperMappingTypes.string],
		],
	},
	{ id: 21, type: TransformFunctionType.StringToNum, dataType: 'number', inputTypes: [['string']] },
	{
		id: 22,
		type: TransformFunctionType.StringToDatetime,
		dataType: 'string',
		inputTypes: [['string'], ['string']],
	},
	{
		id: 24,
		type: TransformFunctionType.StringToObject,
		dataType: 'string',
		inputTypes: [['string']],
	},
	{
		id: 9,
		type: TransformFunctionType.Add,
		dataType: 'number',
		inputTypes: [['number'], ['number']],
	},
	{
		id: 10,
		type: TransformFunctionType.Subtract,
		dataType: 'number',
		inputTypes: [['number'], ['number']],
	},
	{
		id: 11,
		type: TransformFunctionType.Multiply,
		dataType: 'number',
		inputTypes: [['number'], ['number']],
	},
	{
		id: 12,
		type: TransformFunctionType.Divide,
		dataType: 'number',
		inputTypes: [['number'], ['number']],
	},
	{ id: 20, type: TransformFunctionType.NumToString, dataType: 'string', inputTypes: [['number']] },
	{
		id: 25,
		type: TransformFunctionType.RoundUp,
		dataType: 'number',
		inputTypes: [['number'], ['string']],
	},
	{
		id: 26,
		type: TransformFunctionType.RoundDown,
		dataType: 'number',
		inputTypes: [['number'], ['string']],
	},
	{ id: 27, type: TransformFunctionType.MathFloor, dataType: 'number', inputTypes: [['number']] },
	{ id: 28, type: TransformFunctionType.MathCeil, dataType: 'number', inputTypes: [['number']] },
	{
		id: 13,
		type: TransformFunctionType.AddTime,
		dataType: 'date',
		inputTypes: [['date'], ['number']],
	},
	{
		id: 14,
		type: TransformFunctionType.SubtractTime,
		dataType: 'date',
		inputTypes: [['date'], ['number']],
	},
	{
		id: 23,
		type: TransformFunctionType.DatetimeToString,
		dataType: 'date',
		inputTypes: [['date']],
	},
	{
		id: 16,
		type: TransformFunctionType.AddField,
		dataType: 'object',
		inputTypes: [['object'], ['string'], ['string']],
	},
	{
		id: 17,
		type: TransformFunctionType.RemoveField,
		dataType: 'object',
		inputTypes: [['object'], ['string']],
	},
	{
		id: 29,
		type: TransformFunctionType.ObjectToString,
		dataType: 'arrayObject',
		inputTypes: [['object', 'string[]', 'integer[]', 'float[]', 'boolean[]', 'date[]', 'object[]']],
	},
];

export const DataMapperMathFunctions = [
	TransformFunctionType.Add,
	TransformFunctionType.Subtract,
	TransformFunctionType.Multiply,
	TransformFunctionType.Divide,
];
